/**
 * AB Shop Now — AJAX Add to Cart
 */

class ABShopNow {
  constructor(slider) {
    this.slider = slider;
    this.sectionId = slider.dataset.sectionId;
    this.initSwiper();
    this.bindButtons();
  }

  initSwiper() {
    if (typeof Swiper !== 'undefined') {
      this.swiperInstance = new Swiper(this.slider, {
        slidesPerView: 2,
        spaceBetween: 12,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 14,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        }
      });
    }
  }

  bindButtons() {
    this.slider.querySelectorAll('.ab-shop-now__atc-btn:not(.ab-shop-now__atc-btn--oos)').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart(btn);
      });
    });
  }

  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Capture text before loading (innerText returns '' when visibility:hidden)
    const btnText = btn.querySelector('.ab-shop-now__btn-text');
    const originalText = btnText ? (btnText.textContent.trim() || 'ADD TO CART') : 'ADD TO CART';

    // Loading state
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    const cartComponent = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
      try {
        const sectionIds = cartComponent.getSectionsToRender().map((s) => s.id);
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      } catch (_) { /* continue */ }
    }

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.description || data.message || 'Could not add item to cart.');
        return;
      }

      // Publish cart update via Shopify's native pubsub
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ab-shop-now',
          productVariantId: variantId,
          cartData: data,
        });
      }

      // Trigger cart drawer / notification
      if (cartComponent && typeof cartComponent.renderContents === 'function') {
        try { cartComponent.renderContents(data); } catch (_) {
          this.refreshCartBubble();
        }
      } else {
        this.refreshCartBubble();
      }

      // Success feedback
      if (btnText) {
        btnText.textContent = 'Added!';
        setTimeout(() => {
          btnText.textContent = originalText;
        }, 2000);
      }

    } catch (err) {
      console.error('[AB Shop Now] ATC error:', err);
    } finally {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
    }
  }

  async refreshCartBubble() {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await res.json();
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const span = bubble.querySelector('span[aria-hidden="true"]');
        if (span) span.textContent = cart.item_count;
        bubble.classList.remove('hidden');
      });
    } catch (_) {}
  }
}

// Init all sliders on the page
function initABShopNow() {
  document.querySelectorAll('.ab-shop-now__slider[data-section-id]').forEach((slider) => {
    if (!slider.__abShopNow) {
      slider.__abShopNow = new ABShopNow(slider);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initABShopNow);
} else {
  initABShopNow();
}

// Re-init on Theme Editor section reload
document.addEventListener('shopify:section:load', (e) => {
  const slider = e.target.querySelector('.ab-shop-now__slider[data-section-id]');
  if (slider) {
    slider.__abShopNow = new ABShopNow(slider);
  }
});
